/** @format */

import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef } from "react";

interface UndoDeleteProps {
	onCancel: () => void;
	duration: number;
	onExpire: () => void;
}

export const UndoDelete = ({ onCancel, duration, onExpire }: UndoDeleteProps) => {
	const { t } = useTranslation();
	const [offset, setOffset] = useState(0);

	useEffect(() => {
		const timeoutId = setTimeout(() => setOffset(100), 50);
		return () => clearTimeout(timeoutId);
	}, []);

	const onExpireRef = useRef(onExpire);
	onExpireRef.current = onExpire;

	useEffect(() => {
		const timeoutId = setTimeout(() => onExpireRef.current(), duration * 1000);
		return () => clearTimeout(timeoutId);
	}, [duration]);

	return (
		<div className="flex flex-row items-center justify-between w-full">
			<div className="flex items-center gap-3">
				<span className="font-lato font-semibold text-[16px] leading-[150%] text-(--public-color-text-default) ">
					{t("undoDelete.questionRemoved")}
				</span>
				<button
					onClick={onCancel}
					className="font-lato font-semibold text-[16px] leading-[150%] text-(--public-difficulty-pill) underline decoration-solid cursor-pointer"
				>
					{t("undoDelete.undo")}
				</button>
			</div>
			<div>
				<svg className="size-7.5 transform rotate-90" viewBox="0 0 36 36">
					<circle cx="18" cy="18" r="15.9" fill="none" stroke="#5294FF" strokeWidth="4" />

					<circle
						cx="18"
						cy="18"
						r="15.9"
						fill="none"
						stroke="#D9D9D9"
						strokeWidth="4"
						strokeDasharray="100"
						strokeDashoffset={offset}
						strokeLinecap="round"
						transform="scale(-1,1) translate(-36 0)"
						style={{ transition: `stroke-dashoffset ${duration}s linear` }}
					/>
				</svg>
			</div>
		</div>
	);
};
